import { clsx } from 'clsx';
import Link from 'next/link';
import Script from 'next/script';

import { replaceYearString } from '@monoimin/atoms/utils/replaceYearString';
import { Locales } from '@monoimin/sb-types';

import { adjustPathname } from '@monoimin/utils/helpers';

import { getBreadcrumbsUrl } from '../utils/getBreadcrumbsUrl';

export type BreadcrumbsProps = {
  /**
   * массив данных для breadcrumbs json ld и списка ссылок
   */
  listElements: Array<{ name: string | undefined; item: string }>;
  /**
   * класс для контейнера ссылок
   */
  className?: string;
  /**
   * basePath, который нужно подствить в ссылку для breadcrumbs json ld
   */
  basePath?: string;
  /**
   * текущий locale. Необязателен при одной локализации
   */
  locale: Locales;
  hideLayout?: boolean;
  withoutSchema?: boolean;
  site?: MiniSlug;
};

export const Breadcrumbs = ({
  className,
  listElements,
  basePath = '/',
  locale,
  hideLayout = false,
  withoutSchema = false,
  site,
}: BreadcrumbsProps) => {
  const breadCrumbItems = listElements.map((listItem, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: replaceYearString(listItem.name) || '',
    item: adjustPathname(
      getBreadcrumbsUrl({ pathname: listItem.item, locale, basePath, site })
    ),
  }));
  return (
    <>
      {!withoutSchema && (
        <Script id='breadcrumbs-jsonld' type='application/ld+json'>
          {JSON.stringify({
            '@context': 'https://schema.org/',
            '@type': 'BreadcrumbList',
            itemListElement: breadCrumbItems,
          })}
        </Script>
      )}

      {!hideLayout && (
        <ul className={clsx('breadcrumbs', className)}>
          {breadCrumbItems.map((listElement, index) => {
            const { item, name, position } = listElement;

            const isLast = index === listElements.length - 1;

            return (
              <li
                key={position}
                className={clsx('breadcrumbs-list-item', {
                  'br-link': !withoutSchema,
                })}
              >
                {isLast && !withoutSchema ? (
                  <p className='breadcrumbs-list-link'>{name || ''}</p>
                ) : (
                  <Link href={item} className='breadcrumbs-list-link'>
                    {name || ''}
                  </Link>
                )}
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default Breadcrumbs;
